import React, { Suspense } from "react";
import { RouteObject } from "react-router-dom";

import cabinetRoutes from "./routes/cabinet.route";
import RoutesPaths from "./routePath";
import Error from "../Components/UI-KIT/Error";
import noAuthRoutes from "./routes/noAuth.route";
import otherRoutes from "./routes/other.route";
import InitializationStore from "./services/Components/InitializationStore";
import OtherRoutesPaths from "./routes/other.route/other.routesPaths";
import { NotFoundPage } from "../Pages/NotFound.page";
import Loader from "../Components/UI-KIT/Loader";
import GeneralPagesRouter from "./routes/GeneralPages.route/GeneralPagesRouter";

// router внутри `/lk` + страницы не личного кабинета типа `/contacts`
const mainRouter: RouteObject[] = [
	{
		path: RoutesPaths.MAIN,
		errorElement: <Error />,
		element: <InitializationStore />,
		children: [...cabinetRoutes, ...noAuthRoutes, ...otherRoutes],
	},
	{
		path: OtherRoutesPaths.NOT_FOUND,
		element: (
			<Suspense fallback={<Loader />}>
				<NotFoundPage />
			</Suspense>
		),
	},
];
export default mainRouter;

const generalRouter: RouteObject[] = [
	{
		path: "/",
		errorElement: <Error />,
		element: <InitializationStore />,
		children: [...GeneralPagesRouter],
	},
	{
		path: OtherRoutesPaths.NOT_FOUND,
		element: (
			<Suspense fallback={<Loader />}>
				<NotFoundPage />
			</Suspense>
		),
	},
];

export const fullRouter: RouteObject[] = [
	...mainRouter, // маршруты внутри `/lk`
	...generalRouter, // `/contacts` и другие отдельные страницы
];
